export default "__VITE_ASSET__pAnvjpFl__"